import { apiRequest } from "./apiClient";
import { stateChangingRequest } from "./authApi";

export function getArmatures() {
  return apiRequest("/api/armatures");
}

export function createArmature(armature) {
  return stateChangingRequest("/api/armatures", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(armature),
  });
}

export function updateArmature(armatureId, armature) {
  return stateChangingRequest(
    `/api/armatures/${encodeURIComponent(armatureId)}`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(armature),
    },
  );
}

export function updateArmatureVisibility(armatureId, visibility) {
  return stateChangingRequest(
    `/api/armatures/${encodeURIComponent(armatureId)}/visibility`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ visibility }),
    },
  );
}

export function uploadArmatureImage(armatureId, image) {
  const formData = new FormData();
  formData.append("image", image, image.name);
  return stateChangingRequest(
    `/api/armatures/${encodeURIComponent(armatureId)}/images`,
    {
      method: "POST",
      body: formData,
    },
  );
}

export function deleteArmatureImage(armatureId, imageId) {
  return stateChangingRequest(
    `/api/armatures/${encodeURIComponent(
      armatureId,
    )}/images/${encodeURIComponent(imageId)}`,
    { method: "DELETE" },
  );
}

export function reorderArmatureImages(armatureId, imageIds) {
  return stateChangingRequest(
    `/api/armatures/${encodeURIComponent(armatureId)}/images/order`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ imageIds }),
    },
  );
}

export function importArmatures(armatures) {
  return stateChangingRequest("/api/armatures/import", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ armatures }),
  });
}

export function deleteArmature(armatureId) {
  return stateChangingRequest(
    `/api/armatures/${encodeURIComponent(armatureId)}`,
    { method: "DELETE" },
  );
}
